export const fr = {
  locale: 'fr',
  nav: {
    setup: 'Centre de Contrôle',
    news: 'Actualités',
    brand: 'Simu WC26',
    teamName: 'Équipe',
    tactics: 'Tactique',
    fixtures: 'Calendrier',
    standings: 'Classement',
    knockout: 'Phase Finale',
    teamStats: 'Stats Équipe',
    playerStats: 'Stats Joueurs',
  },
  landing: {
    title: 'Simulation de la Coupe du Monde',
    subtitle: 'Du match d\'ouverture à la finale. Choisissez votre place en tant que spectateur ou prenez les rênes en tant que sélectionneur.',
    audienceMode: {
      title: 'Mode Spectateur',
      subtitle: 'Vue Complète du Tournoi',
      desc: 'Parcourez chaque match du tournoi, suivez les actualités, classements, tableaux éliminatoires, statistiques et classements des meilleurs joueurs.',
    },
    coachMode: {
      title: 'Mode Entraîneur',
      subtitle: 'Prenez les Rênes d\'une Équipe Nationale',
      desc: 'Sélectionnez une équipe nationale et prenez place sur le banc. Consultez votre effectif, ajustez la formation, la mentalité, le pressing et l\'orientation offensive avant chaque match.',
    },
    completed: 'Terminés',
    upcoming: 'À Venir',
    championRanking: 'Simulation Champion',
    coachPickRanking: 'Choix Entraîneurs',
    noCompleted: 'Aucun match terminé pour le moment.',
    noUpcoming: '',
    noCoachPick: 'Aucune sélection en mode Entraîneur enregistrée.',
    coachSetup: {
      title: 'Choisissez votre Équipe et Menez-la vers la Gloire',
      back: 'Retour',
      start: 'Commencer mon Parcours',
      processing: 'Création du parcours',
      hiddenTeamsOpen: "Ouvrir Équipes Cachées",
      hiddenTeamsClose: "Fermer Équipes Cachées",
    },
    rosterInfo: 'Groupe {group} · {count} Joueurs',
    simKicker: {
      audience: 'Mode Spectateur · Vue Complète',
      coach: 'Mode Entraîneur · Groupe {group}',
    },
    simTitle: {
      audience: 'Centre de Couverture Complète',
      coach: '{flag} Le Parcours de {name}',
    },
    warning: {
      leave: 'Quitter entraînera la perte des données de simulation.',
      confirm: 'Quitter entraînera la perte des données. Voulez-vous vraiment quitter ?',
    },
    groupLabel: 'Groupe {id}',
    championCount: '{count} fois',
    coachPickCount: '{count} choix',
  },
  common: {
    continue: 'Continuer',
    processing: 'Traitement',
    completed: 'Terminé',
    close: 'Fermer',
    back: 'Retour',
    vs: 'VS',
    restart: 'Nouvelle partie',
    restartConfirm: 'Lancer une nouvelle partie ? La progression actuelle et les données locales seront effacées.',
    playAgain: 'Rejouer',
  },
  team: {
    tab: {
      players: 'Joueurs',
      fixtures: 'Calendrier',
      tactic: 'Tactique',
    },
    playerTable: {
      player: 'Joueur',
      club: 'Club',
      status: 'Statut',
      position: 'Poste',
      ability: 'Note',
      age: 'Âge',
      caps: 'Sel',
      ntGoals: 'B sel',
      apps: 'MJ',
      goals: 'B',
      assists: 'P',
      rating: 'Moy',
    },
    status: {
      redCard: 'Carton Rouge',
    },
    noTactic: 'Cette équipe n\'a pas encore de match terminé. Aucune tactique disponible.',
    tactic: {
      formation: 'Formation',
      mentality: 'Mentalité',
      width: 'Largeur',
      tempo: 'Rythme',
      passing: 'Passes',
      attackRoute: 'Orientation',
      transition: 'Transition',
      pressing: 'Pressing',
      defensiveLine: 'Ligne Défensive',
      possession: 'Possession',
    },
  },
  tactics: {
    formation: 'Formation',
    more: 'Plus de Formations',
    roster: {
      title: 'Effectif',
      order: '#',
      status: 'Statut',
      name: 'Nom',
      position: 'Poste',
      ability: 'Note',
      apps: 'MJ',
      goals: 'B',
      assists: 'P',
    },
    emptySlot: 'Vide',
    noData: 'Aucune donnée tactique',
    benchPrefix: 'Remp',
    starterPrefix: 'XI',
  },
  stats: {
    team: {
      title: 'Statistiques Équipe',
      subtitle: 'Classé par performance cumulée',
      noData: 'Aucune donnée d\'équipe.',
      ranking: 'Classement',
      value: 'Valeur',
      matches: 'Matchs',
    },
    player: {
      title: 'Statistiques Joueurs',
      subtitle: 'Classement Joueurs',
      noData: 'Aucune donnée joueur.',
      nationality: 'Pays',
      value: 'Valeur',
      apps: 'MJ',
    },
    playerTotals: {
      title: 'Totaux de l\'Effectif',
      subtitle: 'Matchs terminés uniquement.',
      noData: 'Votre équipe n\'a pas encore joué.',
    },
    groups: {
      overall: 'Général',
      form: 'Forme',
      discipline: 'Discipline',
      attack: 'Attaque',
      creative: 'Créatif',
      goalkeeping: 'Gardiens',
    },
    items: {
      avgPossession: 'Possession Moy.',
      goalsFor: 'Buts Pour',
      xg: 'xG',
      shots: 'Tirs',
      formText: 'Forme',
      winStreak: 'Série Victoires',
      unbeatenStreak: 'Série Invincibilité',
      winlessStreak: 'Série Sans Victoire',
      scorelessStreak: 'Série Sans But',
      yellowCards: 'Cartons Jaunes',
      redCards: 'Cartons Rouges',
      fouls: 'Fautes',
      goals: 'Buts',
      assists: 'Passes',
      minutesPerGoal: 'Min/But',
      apps: 'Matchs',
      starts: 'Titul.',
      averageRating: 'Note Moy.',
      keyPasses: 'Passes Clés',
      passesAttempted: 'Passes',
      passCompletion: '% Passes',
      saves: 'Arrêts',
    },
    descriptions: {
      avgPossession: 'Possession moyenne dans les matchs terminés',
      goalsFor: 'Total des buts marqués',
      xg: 'xG total accumulé',
      shots: 'Total des tirs',
      formText: 'Forme récente',
      winStreak: 'Victoires consécutives actuelles',
      unbeatenStreak: 'Série d\'invincibilité actuelle',
      winlessStreak: 'Série sans victoire actuelle',
      scorelessStreak: 'Matchs consécutifs sans but',
      yellowCards: 'Total des cartons jaunes',
      redCards: 'Total des cartons rouges',
      fouls: 'Total des fautes',
      playerGoals: 'Classement des buteurs',
      playerAssists: 'Classement des passeurs',
      playerXg: 'Classement xG des joueurs',
      playerShots: 'Classement des tirs',
      minutesPerGoal: 'Minutes par but',
      playerApps: 'Classement des apparitions',
      playerStarts: 'Matchs avec 45+ minutes',
      playerYellowCards: 'Cartons jaunes des joueurs',
      playerRedCards: 'Cartons rouges des joueurs',
      playerAvgRating: 'Note moyenne',
      playerKeyPasses: 'Passes clés des joueurs',
      playerPasses: 'Total des passes tentées',
      playerPassCompletion: 'Pourcentage de passes réussies',
      playerSaves: 'Classement des arrêts',
    },
  },
  position: {
    gk: 'Gardiens',
    def: 'Défenseurs',
    mid: 'Milieux',
    fwd: 'Attaquants',
  },
  stage: {
    'Group Stage': 'Phase de Groupes',
    'Round of 32': '32es de Finale',
    'Round of 16': '8es de Finale',
    'Quarter-final': 'Quart de Finale',
    'Semi-final': 'Demi-finale',
    'Third Place': 'Troisième Place',
    'Final': 'Finale',
  },
  match: {
    penaltyMarker: 'TAB',
    extraTimeMarker: 'AP',
    penalty: {
      scored: 'Réussi',
      missed: 'Raté',
    },
    status: {
      finished: 'Terminé',
      notStarted: 'Pas Commencé',
      pending: 'À Venir',
    },
    viewDetail: 'Voir Détails',
    modal: {
      teamData: 'Stats Équipe',
      playerData: 'Stats Joueurs',
      finalResult: 'Résultat Final',
      restart: 'Rejouer',
      subtitle: {
        extra: '{normal} après le temps réglementaire, {extra} après prol. {extra}.',
        penalty: '{normal} après le temps réglementaire, {extra} après prol., {penalty} aux tirs au but, {winner} qualifié.',
      },
    },
    shootout: 'Tirs au But',
    extraTime: 'Prolongation',
    decision: {
      penalty: ' · TAB {home}-{away}',
      extra: ' · AP {home}-{away}',
    },
    news: {
      penalty: 'Le match s\'est terminé {normal} après le temps réglementaire et {extra} après la prolongation; {winner} a gagné {penalty} aux tirs au but.',
      extraTime: 'Le match s\'est terminé {normal} après le temps réglementaire, avec {goals} buts supplémentaires en prolongation. Score final: {final}.',
    },
    fallback: '{home} et {away} ont terminé {score} en {stage}.',
    eventsFallback: 'Le match s\'est joué dans l\'entrejeu et les détails défensifs.',
    xg: 'xG {home}/{away}',
    possession: 'Possession {home}/{away}',
    shots: 'Tirs {home}/{away}',
    best: 'Meilleur {player}',
    simulate: 'Simuler',
    simTitle: 'Résultats de la simulation',
    simulating: 'Simulation en cours…',
    simProgress: '10 simulations pour ce match',
  },
  fixture: {
    title: 'Calendrier',
    noDate: 'Aucun Jour de Match',
    prevDay: 'Jour précédent',
    nextDay: 'Jour suivant',
  },
  knockout: {
    title: 'Phase Finale',
    subtitle: 'Le chemin des 32es à la Finale',
    tabs: {
      bracket: 'Tableau',
    },
    stageNotGenerated: 'Cette phase n\'a pas encore été générée.',
    tbd: 'TBD',
  },
  standings: {
    rank: 'Rang',
    team: 'Équipe',
    played: 'MJ',
    wins: 'V',
    draws: 'N',
    losses: 'D',
    goalsFor: 'BP',
    goalsAgainst: 'BC',
    goalDiff: 'Diff',
    points: 'Pts',
    filter: 'Filtrer',
  },
  tacticsControls: {
    mentality: {
      label: 'Mentalité',
      options: ['Attaque Totale', 'Attaquer', 'Positif', 'Équilibré', 'Prudent', 'Défensif', 'Verrou'],
    },
    width: {
      label: 'Largeur',
      options: ['Resserré', 'Assez Étroit', 'Normal', 'Assez Large', 'Large'],
    },
    tempo: {
      label: 'Rythme',
      options: ['Lent', 'Assez Lent', 'Normal', 'Assez Rapide', 'Rapide'],
    },
    passing: {
      label: 'Passes',
      options: ['Longues', 'Directes', 'Mixtes', 'Courtes', 'Très Courtes'],
    },
    attackRoute: {
      label: 'Orientation',
      options: ['Ailes', 'Mixte', 'Centre'],
    },
    transition: {
      label: 'Transition',
      options: ['Relancer de la Surface', 'Construire de l\'Arrière', 'Mixte', 'Rapide au Milieu', 'Rapide Devant'],
    },
    defensiveLine: {
      label: 'Ligne Défensive',
      options: ['Basse', 'Normale', 'Haute'],
    },
    pressing: {
      label: 'Pressing',
      options: ['Bas', 'Moyen', 'Haut'],
    },
    possession: {
      label: 'Possession',
      options: ['Repli Défensif', 'Moins de Possession', 'Équilibré', 'Plus de Possession', 'Contrôle Total'],
    },
  },
  formations: {
    '4-2-3-1A': '4 déf., 2 MD, 2 ailiers, 1 MO, 1 attaquant',
    '4-2-3-1S': '4 déf., 2 MD, 1 MC, 2 ailiers, 1 attaquant',
    '4-3-3': '4 déf., 3 milieux, 3 attaquants',
    '4-1-4-1': '4 déf., 1 MD, 4 milieux en ligne, 1 attaquant',
    '4-1-2-2-1': '4 déf., 1 MD, 2 MC, 2 ailiers, 1 attaquant',
    '4-3-1-2M': '4 déf., 3 MC, 1 MO, 2 attaquants',
    '4-3-1-2D': '4 déf., 3 MD, 1 MC, 2 attaquants',
    '4-3-2-1M': '4 déf., 3 MC, 2 MO, 1 attaquant',
    '4-3-2-1D': '4 déf., 3 MD, 2 MC, 1 attaquant',
    '4-3-2-1S': '4 déf., 3 MC, 2 ailiers, 1 attaquant',
    '4-4-1-1': '4 déf., 4 milieux en ligne, 1 MO, 1 attaquant',
    '4-2-2-2': '4 déf., 2 MD, 2 ailiers, 2 attaquants',
    '4-4-2F': '4 déf., 4 milieux en ligne, 2 attaquants',
    '4-4-2D': '4 déf., milieu en losange, 2 attaquants',
    '3-3-2-2': '3 DC, 2 piston, 1 MD, 2 MC, 2 attaquants',
    '3-2-4-1': '3 DC, 2 MD, 2 larges, 2 MC, 1 attaquant',
    '3-2-2-2-1': '3 DC, 2 piston, 2 MC, 2 ailiers, 1 attaquant',
    '3-2-3-2D': '3 DC, 2 MD, 2 larges, 1 MC, 2 attaquants',
    '3-2-3-2W': '3 DC, 2 piston, 3 MC, 2 attaquants',
    '3-4-1-2': '3 DC, 2 piston, 2 MD, 1 MO, 2 attaquants',
    '3-4-2-1S': '3 DC, 2 piston, 2 MD, 2 ailiers, 1 attaquant',
    '3-4-2-1C': '3 DC, 2 piston, 2 MD, 2 MO, 1 attaquant',
    '3-4-3F': '3 DC, 4 milieux en ligne, 3 attaquants',
    '3-4-3D': '3 DC, milieu en losange, 3 attaquants',
    '5-3-2': '5 déf., 3 MC, 2 attaquants',
    '5-4-1F': '5 déf., 4 milieux en ligne, 1 attaquant',
    '5-4-1D': '5 déf., milieu en losange, 1 attaquant',
    '5-2-2-1': '5 déf., 2 MD, 2 ailiers, 1 attaquant',
  },
  news: {
    title: 'Actualités',
    subtitle: 'Mises à jour des matchs',
    titleTexts: {
      groupRecap: 'Bilan de la Phase de Groupes : Qualifiés, Surprises et Classements',
      knockoutRecap: 'Bilan des {stage} : Qualifiés et Tournants Clés',
      stagePreview: 'Aperçu des {stage} : Duels Clés et Pronostics',
      championRoad: 'Le Chemin vers la Gloire de {flag} {name}',
      awards: 'Récompenses de la Coupe du Monde : Meilleur Joueur, Meilleur Buteur et Meilleur Gardien',
      review: 'Bilan de la Coupe du Monde : Champion, Surprises, Scores et Héros',
      coachSummary: 'Bilan de la Campagne de {team}',
    },
    kicker: {
      author: 'Message de l\'Auteur',
      guide: 'Guide Rapide',
      welcome: {
        coach: 'Bienvenue sur le Banc',
        audience: 'Bienvenue au Centre',
      },
      stageRecap: 'Résumé · {stage}',
      stagePreview: 'Aperçu · {stage}',
      champion: 'Histoire du Champion',
      awards: 'Récompenses',
      tournamentReview: 'Bilan du Tournoi',
      pregame: 'Avant-Match',
      coachSummary: 'Résumé de Campagne',
    },
    default: {
      title: 'Simulation pas encore lancée',
      body: 'Une fois que vous aurez choisi un mode, les actualités commenceront.',
    },
    guide: {
      title: 'Continuer vous fera d\'abord lire les news, puis avancer la journée',
      body: 'Le bouton {Continuer} se trouve en haut à droite de la page. En mode Spectateur, les news non lues sont affichées en premier. Après les avoir lues, vous verrez le calendrier du jour. Cliquez à nouveau sur {Continuer} pour simuler les matchs du jour.',
    },
    author: {
      title: 'Un (grand) mot de remerciement de l\'auteur',
      body: 'Merci d\'avoir supporté les goûts esthétiques d\'un programmeur qui a enchaîné les nuits blanches. Si la simulation vous a plu, félicitez l\'auteur ; si le résultat est un scandale… eh bien, c\'est ça la beauté du foot ! Pour tout retour, contactez-moi sur x.com/diysimon ou Xiaohongshu (diysimon).',
    },
    finalThanks: {
      title: 'Tournoi Terminé — Merci d\'avoir Joué !',
      body: 'La Coupe du Monde 2026 touche à sa fin. Merci d\'avoir vécu cette simulation ! Suivez l\'auteur (X @diysimon / Xiaohongshu diysimon) pour les mises à jour, retours et futurs projets. N\'hésitez pas à lancer une nouvelle partie et essayer un chemin différent !',
    },
    coachSummary: {
      intro: 'Votre aventure avec {team} est terminée. L\'équipe se classe {position}.',
      record: 'Durant le tournoi, {team} totalise {wins} victoire(s), {draws} nul(s), {losses} défaite(s), {goalsFor} but(s) marqué(s) et {goalsAgainst} encaissé(s).',
      position: '{team} termine {position}.',
      exit: 'Ils ont été éliminés en {stage} par {opponent}.',
      exitNone: 'Ils ont terminé le tournoi invaincus en phase finale.',
      topScorer: 'Meilleur buteur : {name} avec {goals} but(s).',
      noScorer: 'Aucun joueur ne s\'est particulièrement distingué au classement des buteurs.',
      bestWin: 'Plus large victoire : {match}.',
      meta: '{wins}V {draws}N {losses}D | {goalsFor}BP {goalsAgainst}BC | {position}',
      factRecord: 'Bilan : {wins}V {draws}N {losses}D',
      factGoals: 'Buts : {goalsFor} Pour / {goalsAgainst} Contre (diff {diff})',
      factTopScorer: 'Meilleur buteur : {name} ({goals} buts)',
      factChampion: '{team} est Champion du Monde !',
      factFinish: 'Position finale : {position}',
      positions: {
        champion: 'Champion',
        runnerUp: 'Finaliste',
        semiFinal: 'Demi-finaliste',
        quarterFinal: 'Quart-de-finaliste',
        round16: '8es de Finale',
        round32: '32es de Finale',
        groupStage: 'Phase de Groupes',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} commence son parcours',
        body: 'Vous avez pris les rênes de {name}. Utilisez le menu de gauche pour voir votre équipe, tactique, calendrier et statistiques.',
      },
      audience: {
        title: 'Simulation complète de la Coupe du Monde 2026 chargée',
        body: 'Vous regardez le tournoi en tant que spectateur. Le système avance match par match.',
      },
    },
    facts: {
      thanks: 'Merci d\'avoir joué',
      feedback: 'Retours bienvenus',
      entertainment: 'Simulation à but ludique',
      newsFirst: 'News les plus récentes d\'abord',
      fixtureBrowse: 'Calendrier par journée',
      resultsGenerate: 'Les résultats génèrent des news',
      newsUpdates: 'News mises à jour en direct',
      timeline: 'Calendrier des matchs à venir',
      refreshWarning: 'Actualiser ou quitter perd la simulation',
      operation: 'Comment jouer',
      preMatch: 'Briefing avant-match',
    },
    narrative: {
      intro: {
        penalty: '{winner} s\'est imposé {score} aux tirs au but après un {stage} tendu.',
        extraTime: '{winner} l\'a emporté {winnerScore} après la prolongation pour décrocher une victoire {stage} âprement disputée.',
        win: [
          '{winner} a contrôlé le tempo lors des {stage} et s\'est imposé {score}.',
          '{winner} a surpassé son adversaire par un jeu solide des deux côtés, s\'imposant {score} en {stage}.',
          '{winner} a saisi les moments clés de ce duel des {stage}, s\'imposant {score}.',
          '{winner} n\'a pas laissé passer sa chance en {stage}, concluant sur une victoire {score}.',
          'Les {stage} ont été âprement disputés d\'entrée, mais le but décisif de {winner} a scellé le score à {score}.',
        ],
        draw: [
          'Un {stage} tendu s\'est terminé sur un score nul : {home} et {away} finissent {score}.',
          '{home} et {away} ont échangé des coups en {stage}, mais aucun n\'a trouvé la faille — score final {score}.',
          'Les {stage} se terminent sans vainqueur : {home} et {away} se partagent les points sur le score de {score}.',
        ],
      },
      noEvent: [
        'Aucune des deux équipes n\'a réussi à créer une percée décisive. Le match a été marqué par des batailles au milieu de terrain et des blocs compacts dans le dernier tiers.',
        'Les deux défenses ont bien tenu leur position, laissant peu d\'occasions franches de but.',
        'La finition a été le thème du match — les actions prometteuses ont constamment échoué au dernier moment.',
      ],
      goal: {
        extraTime: [
          '{minute}, la prolongation entre dans sa phase critique. {scorer} a repris la passe de {assister} et {method} pour faire {score}.',
          '{minute}, {team} a saisi son occasion en prolongation : {scorer} {method} devant le gardien, {team} {state}.',
          '{minute}, alors que les jambes s\'alourdissent et que les espaces s\'ouvrent, {scorer} {method} calmement pour envoyer le ballon au fond, faisant {score}.',
          '{minute}, {scorer} a offert l\'instant décisif en prolongation, {method} pour remettre {team} aux commandes.',
        ],
        withAssist: [
          '{minute}, {scorer} a repris le centre de {assister} venu de la droite, {method} devant le défenseur pour faire {score}, {team} {state}.',
          '{minute}, {assister} a glissé une passe décisive, {scorer} s\'en est saisi et {method}, {team} {state}.',
          '{minute}, {team} a combiné avec rapidité. {assister} a remisé pour {scorer}, qui {method} pour faire {score}.',
          '{minute}, {scorer} a profité du service de {assister}, {method} devant le gardien impuissant, {team} {state}.',
          '{minute}, {assister} a joué une passe qui a transpercé les lignes, {scorer} l\'a prise en mouvement et {method} pour marquer — {score}.',
          '{minute}, {team} a récupéré haut sur le terrain et a joué vite. {assister} a remisé vers {scorer}, qui {method}.',
          '{minute}, {assister} a envoyé le coup de pied arrêté dans la surface. {scorer} a surgi dans la foule et {method}, {team} {state}.',
          '{minute}, {scorer} a repris le ballon en retrait de {assister} et {method} en une touche — l\'action a porté le score à {score}.',
          '{minute}, {assister} a attiré les défenseurs avant de remiser. {scorer} a trouvé l\'espace et {method}, {team} {state}.',
          '{minute}, {team} a patiemment fait circuler le ballon jusqu\'à ce que l\'espace s\'ouvre. {assister} a délivré la passe décisive et {scorer} {method}.',
        ],
        solo: [
          '{minute}, {scorer} a semé un défenseur à l\'entrée de la surface et {method}, {team} {state} — {score}.',
          '{minute}, {scorer} a surgi sur un dégagement raté et {method} dans le but vide.',
          '{minute}, {scorer} est parti du milieu de terrain et a décoché un {method} dans le filet.',
          '{minute}, le pressing haut de {team} a semé la panique. {scorer} a réagi le plus vite, {method} pour faire {score}.',
          '{minute}, {scorer} a réagi le premier dans la mêlée, {method} à bout portant, {team} {state}.',
        ],
        methodHigh: ['de la tête', 'poussé', 'piqué', 'repris à bout portant'],
        methodLow: ['frappe lointaine', 'enroulé', 'tir de loin', 'volée'],
        methodMid: ['frappé', 'glissé', 'décoché', 'fini calmement', 'tir en angle'],
      },
      chance: [
        '{minute}, {team} a failli {chanceState}. {player} était lancé vers le but mais le gardien a eu le dernier mot.',
        '{minute}, {player} a eu une occasion en or dans la surface mais a manqué sa frappe au dernier moment.',
        '{minute}, {team} est parti rapidement en contre-attaque, mais la tentative de {player} a filé juste à côté du poteau.',
        '{minute}, {player} a bien suivi le centre mais n\'a pas réussi à cadrer sa reprise.',
      ],
      redCard: [
        '{minute}, {team} a reçu un coup dur : {player} a écopé d\'un carton rouge, changeant la dynamique du match.',
        '{minute}, {player} a été expulsé, obligeant {team} à resserrer les rangs pour le reste du match.',
        '{minute}, l\'arbitre a sorti le rouge pour {player}. Le plan de jeu de {team} a dû changer sur-le-champ.',
      ],
      flow: {
        xgGap: '{dominant} s\'est créé les meilleures occasions, menant {xgHome}-{xgAway} au xG et {shotsHome}-{shotsAway} aux tirs.',
        possession: '{controller} a dominé la possession avec {possession}% de possession, mais l\'efficacité dans la surface a primé.',
        balanced: 'L\'écart de qualité des occasions était mince ({xgHome}-{xgAway} xG), le match s\'est joué en transition et dans l\'exécution finale.',
      },
      tactic: {
        control: [
          'Sur le plan tactique, {controller} a dicté le tempo, faisant circuler le ballon avec des passes patientes et {possession}% de possession.',
          'Le plan de {controller} était clair : garder le ballon, explorer les ailes et les demi-espaces, et empêcher {away} de prendre son rythme.',
          '{controller} a utilisé la possession prolongée pour affaiblir le pressing adverse, gardant le match sous contrôle.',
          '{controller} est resté compact et patient en possession, transformant la conservation du ballon en plus de temps passé dans le dernier tiers.',
        ],
        direct: [
          '{direct} n\'a pas cherché la possession — ils ont privilégié l\'envoi rapide du ballon dans la surface, et plus de tirs ont reflété cette approche.',
          'En attaque, {creator} a été plus incisif pour trouver les zones dangereuses, et leur avantage aux passes clés a maintenu la défense sous pression.',
          '{direct} a fait circuler le ballon avec détermination, contournant l\'entrejeu pour amener le jeu directement au but.',
          '{creator} a montré une plus grande variété dans le dernier tiers — centres, passes en profondeur et deuxièmes ballons ont tous créé de réelles menaces.',
        ],
        pressure: [
          '{presser} a réalisé un énorme travail sans ballon, rendant difficile la première relance adverse.',
          'La discipline défensive de {presser} a été remarquable — les milieux sont revenus rapidement pour éteindre le danger avant qu\'il n\'atteigne la surface.',
          'L\'intensité physique était élevée. {presser} a coupé les lignes de passes avec un pressing incessant et des courses de récupération.',
          '{presser} a été agressif dans la récupération du ballon après l\'avoir perdu — menant pas toujours à des tirs, mais étouffant les contre-attaques.',
        ],
        balanced: [
          'Les deux équipes ont fait preuve de prudence dans l\'exécution, gardant des blocs compacts et laissant le match se décider dans les duels et les deuxièmes ballons.',
          'Ce n\'était pas un match ouvert. Aucune des deux équipes n\'a abandonné sa structure défensive, comptant sur quelques passes clés pour faire la différence.',
          'Les deux équipes ont géré le risque avec soin, limitant les projections offensives. Le match a été façonné par une poignée de moments de grande qualité.',
          'Sur le plan tactique, les équipes se sont neutralisées : l\'une tentait d\'accélérer, l\'autre bouchait les espaces centraux.',
          'Les batailles au milieu de terrain ont constamment interrompu le rythme, montrant que les deux équipes privilégiaient les transitions défensives.',
        ],
      },
      coach: {
        late: [
          'La patience du staff technique a payé. {winner} n\'a pas forcé en seconde période, attendant que l\'adversaire s\'essouffle avant de porter le coup décisif.',
          'Les changements et la structure de {winner} sont restés synchronisés, permettant une pression soutenue en fin de match — un signe de bonne gestion.',
          '{winner} a conservé sa structure dans l\'impasse. Le but tardif était le résultat naturel d\'une pression soutenue plutôt que d\'un coup de désespoir.',
          'Le staff de {winner} a choisi de continuer à pousser en fin de match, une décision qui leur a offert le moment décisif.',
        ],
        red: [
          'Après le carton rouge, le staff de {redTeam} a ajusté la défense, s\'appuyant sur un bloc compact et des sorties rapides pour rester dans le match.',
          '{opponent} a tenté d\'étirer le jeu avec l\'homme supplémentaire, mais la réponse compacte de {redTeam} a empêché le match de leur échapper.',
          'Jouer en infériorité numérique a testé l\'adaptabilité de {redTeam}. Ils ont réduit les passes risquées dans l\'entrejeu et privilégié la solidité défensive.',
          'Le staff de {opponent} a exigé une circulation plus rapide du ballon après le rouge, tentant de transformer l\'avantage numérique en surnombre sur les ailes.',
        ],
        narrow: [
          'Le staff de {winner} a fait un choix pragmatique — après avoir pris l\'avantage, ils n\'ont pas cherché plus de buts, mais ont protégé leur avance avec un placement solide.',
          '{winner} a privilégié le contrôle après avoir marqué, réduisant les risques inutiles et gardant le match sous contrôle.',
          '{winner} a gagné sans excès. La gestion des risques du staff était parfaite, laissant {loser} peu d\'occasions de revenir.',
          'La victoire reflète l\'approche réaliste de {winner} : sécuriser la défense d\'abord, puis laisser les joueurs offensifs décider du match.',
        ],
        win: [
          '{winner} a exécuté son plan de jeu efficacement, maintenant la structure offensive même après avoir pris l\'avantage.',
          '{winner} s\'est positionné intelligemment dans les transitions. Le staff a clairement exigé une pression immédiate sur le ballon après l\'avoir perdu.',
          'La victoire de {winner} ne tenait pas seulement à la qualité individuelle — leur structure et la protection des deuxièmes ballons ont soutenu le score.',
          '{winner} a fait preuve d\'une gestion mature du match, sachant quand pousser et quand garder le ballon.',
        ],
        draw: [
          'Aucun des deux staffs techniques n\'a pris tous les risques dans ce match nul. Les changements tardifs et le placement penchaient vers l\'évitement de la défaite.',
          'Les deux équipes ont essayé de créer par les ailes, mais la défense centrale n\'a jamais été véritablement percée.',
          'Le match nul reflète la prudence des deux entraîneurs : l\'intention offensive était là, mais aucun ne s\'est totalement engagé vers l\'avant.',
          'Les deux équipes ont renforcé la protection du milieu en fin de match, plus préoccupées par une contre-attaque décisive.',
        ],
      },
      player: {
        goals: [
          '{player} a été le nom marquant, changeant le match avec plusieurs finitions et obtenant une note de {rating}.',
          'L\'instinct de finition de {player} a décidé du match — ses appels ont constamment trouvé les zones les plus difficiles à défendre.',
          'L\'attaque de {team} a été conclue par {player}, dont le calme devant le but a maintenu la défense adverse sous pression constante.',
          '{player} a été le détonateur, transformant les occasions en réelle pression au tableau d\'affichage.',
        ],
        attack: [
          '{player} a été influent dans les moments clés. Au-delà des buts et passes, son jeu de liaison a permis à {team} de progresser.',
          'La contribution de {player} va au-delà des statistiques — il apparaissait là où l\'attaque avait besoin d\'un point d\'ancrage.',
          '{player} a saisi sa fenêtre dans ce match, prenant les décisions clés qui ont donné un point focal à l\'attaque de {team}.',
          '{player} a été décisif dans le dernier tiers — sachant quand passer et quand tirer, un exutoire fiable pour {team}.',
          'Les déplacements de {player} ont créé des espaces, et son implication directe a fait basculer la dynamique du match.',
        ],
        saves: [
          'Le travail de {player} dans les buts a été vital. Plusieurs arrêts ont maintenu {team} dans le match.',
          'Le gardien {player} mérite une mention spéciale, enchaînant les arrêts pour priver l\'adversaire du but.',
          '{team} a tenu sous pression grâce aux réflexes de {player} — ses arrêts ont été un facteur clé.',
          '{player} avait peu de marge d\'erreur, mais a tout géré proprement, restant calme même face aux tentatives à bout portant.',
        ],
        create: [
          '{player} a été le lien le plus important de {team} dans le dernier tiers, créant des opportunités de tir pour ses coéquipiers avec des passes clés.',
          'La vision de {player} a façonné les schémas offensifs de {team} — trouvant constamment des lignes de passe dans les zones congestionnées.',
          '{team} avait besoin de quelqu\'un pour envoyer le ballon dans les zones dangereuses, et {player} a parfaitement rempli ce rôle.',
          '{player} ne cherchait pas seulement les buts — il utilisait les passes pour placer ses coéquipiers dans de meilleures positions de tir.',
        ],
        defense: [
          '{player} a couvert énormément de terrain défensivement, avec des tacles et interceptions qui ont solidifié le bouclier du milieu de {team}.',
          '{team} a limité la progression adverse grâce au replacement et à l\'anticipation de {player}.',
          'La valeur de {player} résidait dans le travail sans ballon, brisant constamment les actions de passes adverses avant qu\'elles ne se développent.',
          '{player} mérite d\'être reconnu pour son travail défensif, sauvant {team} de plusieurs situations dangereuses autour de la surface.',
        ],
        shots: [
          '{player} n\'a pas converti ses occasions en buts, mais ses tirs constants ont maintenu la défense adverse sous pression.',
          'Une grande partie de la menace offensive de {team} venait de {player}, qui n\'a cessé de tenter sa chance.',
          'L\'agressivité de {player} était notable — de multiples tirs montraient qu\'il trouvait constamment de l\'espace dans le dernier tiers.',
          '{player} n\'était pas loin du but — ses tentatives ont déjà forcé le gardien adverse à être en alerte maximale.',
        ],
        general: [
          '{player} a obtenu l\'une des meilleures notes, offrant un jeu solide des deux côtés du terrain pour {team}.',
          'Les chiffres de {player} ne disent pas tout — son implication était cruciale pour maintenir {team} dans le rythme.',
          'La performance complète de {player} a été la plus remarquée, faisant les bons choix dans de multiples situations.',
          'La valeur de {player} résidait dans sa fiabilité — gaspillant rarement le ballon et toujours disponible pour le travail défensif.',
        ],
      },
      impact: {
        finalWin: '{winner} a gagné la finale et soulevé le trophée de la Coupe du Monde. Le parcours de {loser} s\'est arrêté à une marche du sommet.',
        thirdPlace: '{winner} termine troisième de la Coupe du Monde, tandis que {loser} prend la quatrième place.',
        semiFinal: '{winner} s\'est qualifié pour la finale avec cette victoire, mettant fin aux espoirs de {loser} de soulever le trophée.',
        quarterFinal: '{winner} a atteint les demi-finales, à une victoire de la finale.',
        knockoutWin: '{winner} progresse en phase finale, tandis que {loser} est éliminé.',
        placementBothDark: 'Les deux équipes ont largement dépassé leurs cotes de pré-tournoi — le match pour la troisième place était lui-même un exploit d\'outsider.',
        placementThirdDark: '{thirdName} a terminé sur le podium alors qu\'elle était en dehors du top 20 des cotes de pré-tournoi, dépassant toutes les attentes.',
        placementFourthDark: '{fourthName} a perdu ce match, mais atteindre les demi-finales a déjà dépassé les attentes de pré-tournoi.',
        placementBothFavored: 'Les deux équipes figurent parmi le top 20 des cotes de pré-tournoi, et atteindre le dernier carré correspond largement aux attentes.',
        groupLead: '{teamName} a {points} point(s) en {played} match(s) de groupe, {rank} du groupe et en bonne position pour se qualifier.',
        groupEliminated: '{teamName} n\'a que {points} point(s) en {played} match(s), {rank} du groupe et ne peut plus se qualifier.',
        groupUpdate: 'Après ce match, {teamName} totalise {points} point(s), actuellement {rank} du Groupe {group}.',
        groupQualifiers: 'Groupe {groupId} : {names}',
        qualified: 'qualifié',
        eliminated: 'éliminé',
        favoriteStatus: '{name} {status}',
        darkHorses: '{names} sont les outsiders les plus notables de cette phase, surpassant les attentes en points, différence de buts ou matchs clés.',
        noDarkHorses: 'Dans l\'ensemble, les favoris ont tenu leur rang — les classements de groupe n\'ont pas connu de bouleversement majeur.',
        unbeaten: '{names} reste invaincu, faisant preuve d\'une constance impressionnante.',
        scorers: 'Individuellement, {scorerLine}. {assisterLine}.{ratingLine}',
        scorerLead: '{name} mène le classement des buteurs avec {goals} but(s)',
        scorerDisperse: 'La course au titre de meilleur buteur reste ouverte',
        assisterLead: '{name} mène le classement des passeurs avec {assists} passe(s)',
        assisterDisperse: 'Le classement des passes décisives reste serré',
        ratingHighlight: ' {name} a une moyenne de {rating} — l\'un des joueurs les plus remarquables de la phase de groupes.',
      },
      recap: {
        groupIntro: [
          'La phase de groupes est terminée. 32 équipes se sont qualifiées et la Coupe du Monde passe en phase finale.',
          '72 matchs de groupe sont dans les livres. Les qualifiés, les surprises et les classements individuels ont pris forme.',
          'Phase de groupes terminée. La constance des meilleures équipes, les percées des outsiders et la course au but ont défini cette phase.',
        ],
        knockoutIntro: 'Les {stage} sont terminés. {count} équipes restent en lice pour le titre.',
        knockoutWinners: '{names} ont décroché leur ticket pour le tour suivant.',
        knockoutTight: '{count} match(s) se sont joués à un but d\'écart ou aux tirs au but — la tension monte en phase finale.',
        knockoutClear: 'Les résultats de ce tour ont été relativement nets, les vainqueurs montrant une plus grande maîtrise.',
        knockoutBiggest: 'Le match le plus ouvert du tour a été {match}, avec {goals} but(s) au total.',
        knockoutUpset: 'La surprise est venue de {winner} qui a battu {loser} — l\'équipe la moins bien classée a produit la performance la plus efficace.',
        knockoutScorers: 'Individuellement, {scorerLine} ; {ratingLine}',
        knockoutScorerLead: '{name} mène toujours le classement des buteurs avec {goals} but(s)',
        knockoutScorerDisperse: 'La course au titre de meilleur buteur reste très ouverte',
        knockoutRating: '{name} maintient une note élevée, l\'une des stars les plus constantes de la phase finale.',
        knockoutRatingGeneric: 'La forme des joueurs clés commence à façonner la course au titre.',
        groupLines: 'Qualifiés par groupe : {lines}. {favorites}',
        groupFavorites: 'Parmi les favoris, {status}.',
        groupQualifierFormat: 'Groupe {groupId} : {names}',
        groupMeta: '{count} qualifié(s) · {scorerInfo}',
        scorerInfo: 'Buteur {name}',
        scorerInfoUpdate: 'Stats mises à jour',
        factQualified: '{count} qualifié(s)',
        factDarkHorses: 'Outsiders {names}',
        factStable: 'Favoris stables',
        factTopScorer: 'Meilleur buteur {name} {goals}B',
        factTopAssister: 'Meilleur passeur {name} {assists}P',
        knockoutMeta: '{count} qualifié(s) · {tight} serré(s)',
        factKnockoutTight: '{count} match(s) serré(s)',
        factKnockoutClear: 'Résultats nets',
        factUpset: 'Surprise {winner}',
        factOpen: '{goals} but(s)',
      },
      preview: {
        intro: 'Les affiches des {stage} sont connues. La prochaine phase réduira le plateau en {count} match(s).',
        keyMatch: 'Duels clés à suivre : {matches}.',
        noKeyMatch: 'Aucun choc direct entre équipes du top 20 des cotes à ce stade — les favoris doivent éviter les faux pas dans des rencontres a priori favorables.',
        favorites: 'Sur la forme et la force de l\'effectif, {names} sont favoris pour se qualifier.',
        noFavorites: 'L\'écart est mince à ce tour — la forme et la finition pourraient compter plus que la réputation.',
        tail: [
          'En phase finale, la gestion du match, la défense sur coups de pied arrêtés et la forme du gardien deviennent cruciales. Une erreur peut redessiner tout le tableau.',
          'Cette phase ne se résume pas à la puissance offensive. Le timing des changements, la gestion des risques et la préparation des tirs au but influenceront les résultats.',
          'Les favoris doivent éviter les débuts lents tandis que les outsiders cherchent à entraîner le match dans leur zone de confort. Les 30 premières minutes donneront le ton.',
        ],
        previewMeta: '{count} match(s)',
        factMatchup: '{count} duel(s)',
        factFocus: 'Focus {matchup}',
        factFavorite: 'Favori {name}',
      },
      champion: {
        road: 'Le chemin vers la gloire de {champion} est complet : {count} match(s), {wins} victoire(s), {draws} nul(s), {goalsFor} but(s) marqué(s), {goalsAgainst} encaissé(s).',
        groupPath: 'En phase de groupes, {champion} s\'est qualifié rapidement : {matches}.',
        knockoutPath: 'En phase finale, ils ont éliminé {opponents}.',
        signatureMatch: '{match} a été la performance phare de leur campagne.',
        meta: '{wins}V{draws} · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}N',
        fact: 'Champion {champion}',
        factGoal: 'Buts {goalsFor}',
        factConcede: 'Encaissés {goalsAgainst}',
        factSignature: 'Match réf. {match}',
        tail: [
          'La marque de fabrique de ce champion était la stabilité : contrôler les matchs en menant et trouver de nouvelles solutions offensives en étant mené ou bloqué.',
          'Leur titre ne reposait pas sur un seul éclat — il venait de la solidité défensive, du rendement constant des joueurs clés et d\'une gestion avisée.',
          'Ce qui distinguait le champion, c\'est de ne jamais s\'être laissé briser par un mauvais résultat, gérant chaque tour de phase finale avec sang-froid.',
        ],
      },
      awards: {
        intro: 'La finale terminée, les récompenses individuelles de la Coupe du Monde ont été décernées. {bestPlayer}',
        bestPlayer: '{name} a remporté le titre de Meilleur Joueur grâce à des notes élevées constantes et des performances clés.',
        noBestPlayer: 'La course au Meilleur Joueur a été extrêmement serrée, avec de nombreuses stars produisant des performances de classe mondiale.',
        topScorer: 'Le Soulier d\'Or revient à {name} avec {goals} but(s) — le finisseur le plus fiable du tournoi.',
        noTopScorer: 'Le classement des buteurs n\'a pas eu de leader incontesté, mais l\'efficacité des attaquants a quand même décidé de nombreux matchs.',
        topAssister: 'Aux passes décisives, {name} mène avec {assists} — ses transmissions ont directement changé plusieurs matchs.',
        bestKeeper: 'Le Meilleur Gardien est {name}, avec {saves} arrêt(s) et une moyenne de {conceded} but(s) encaissé(s) par match.',
        noBestKeeper: 'La course au meilleur gardien s\'est concentrée parmi quelques performers réguliers de la phase finale.',
        scorerFallback: 'le leader du classement des buteurs',
        keeperFallback: 'un candidat au titre de meilleur gardien',
        summary: '{names} incarnent le récit individuel de ce tournoi — l\'un créait, l\'autre finissait, le troisième verrouillait.',
        noSummary: 'Les performances individuelles étaient fortement liées aux systèmes d\'équipe, façonnées par les cadres tactiques autant que par la qualité personnelle.',
      },
      review: {
        intro: 'Le tournoi est terminé. Les {total} matchs ont produit {goals} buts, soit une moyenne de {average} par match.',
        scoring: '{highScoring} match(s) ont vu 4 buts ou plus, et {btts} match(s) ont vu les deux équipes marquer. {biggest}',
        biggest: 'Le match le plus ouvert a été {match}.',
        upsetSep: 'a battu',
        assisterFallback: 'plusieurs créateurs',
        ratingFallback: 'joueurs clés',
        upsets: 'Les surprises incluent {upsets}.',
        noUpsets: 'Pour l\'essentiel, les favoris ont confirmé leur avantage sur le papier, même si les rencontres se sont souvent jouées à peu de chose.',
        champion: 'Au final, {champion} a gardé son sang-froid le plus longtemps, devenant l\'histoire marquante du tournoi.',
        leaders: 'Individuellement, la finition de {scorer}, la créativité de {creators} et les notes élevées de {ratings} ont formé la colonne vertébrale statistique du tournoi.',
        noLeaders: 'Ce tournoi a eu à la fois de la domination et de la surprise — les histoires réelles étaient plus riches que n\'importe quelle ligne statistique.',
        awardsMeta: 'Meilleur Joueur {name}',
        awardsMetaDefault: 'Aperçu des récompenses',
        factBestPlayer: 'Meilleur Joueur {name}',
        factTopScorer: 'Meilleur buteur {name} {goals}B',
        factBestKeeper: 'Meilleur Gardien {name}',
        factTopAssister: 'Meilleur passeur {name} {assists}P',
        reviewMeta: '{count} match(s) · {goals} but(s)',
        factTotalGoals: 'Total buts {goals}',
        factAvgGoals: 'Moy. {average} par match',
        factHighScoring: '{count} avec 4+ buts',
        factBothScored: '{count} les deux ont marqué',
      },
    },
  },
  helpers: {
    formText: { W: 'V', D: 'N', L: 'D' },
    goalState: {
      equalize: 'égaliser',
      lead: 'prendre l\'avantage',
      extend: 'creuser l\'écart',
      chase: 'réduire le score',
    },
    chanceState: {
      extend: 'creuser l\'écart',
      break: 'ouvrir le score',
      face: 'sauver l\'honneur',
      close: 'réduire l\'écart',
    },
    tacticSummary: 'Mentalité {mentality} · Jeu {focus} · Pressing {pressing} · Ligne {line}',
    teamMate: 'un coéquipier',
    attacker: 'un attaquant',
    defender: 'un défenseur',
    advance: ' qualifié',
    groupLeader: 'Groupe {group} : {teamName} en tête, {points} pts',
    unknownPlayer: 'Joueur inconnu',
    unsolved: 'N/D',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['Joueur', 'Pos', 'MJ', 'Min', 'B', 'P', 'xG', 'Tir', 'TC', 'Pas', 'R', 'PC', 'Tkl', 'Int', 'CJ', 'CR', 'Arr', 'Note'],
    },
    matchStats: {
      shotsOnTarget: 'Tirs Cadrés',
      passes: 'Passes',
      passSuccess: '% Passes',
      keyPasses: 'Passes Clés',
      corners: 'Corners',
      offsides: 'Hors-jeu',
      fouls: 'Fautes',
      yellowCards: 'Cartons Jaunes',
      redCards: 'Cartons Rouges',
      saves: 'Arrêts',
      tackles: 'Tacles',
      interceptions: 'Interceptions',
    },
    modal: {
      best: 'Meilleur',
      record: 'Bilan',
      stage: 'Phase',
      bestPlayer: 'Meilleur Joueur',
      signature: 'Match Référence',
    },
    bracket: {
      pending: 'À venir',
    },
  },
  mobile: {
    landing: { intro: 'Simulateur Coupe du monde 2026', description: 'Du match d’ouverture à la finale, touchez Continuer pour suivre toute la simulation de la Coupe du monde 2026.', welcome: 'Bienvenue dans votre propre temps de Coupe du monde. Touchez pour simuler rapidement et prédire qui soulèvera le trophée. Sur PC, le mode entraîneur est aussi disponible.', hiddenStart: 'Simuler avec équipes cachées', start: 'Lancer la simulation', startTitle: 'Lancer la simulation', startSubtitle: 'Équipes réelles, groupes réels : regardez toute la Coupe du monde en mode spectateur en moins de dix minutes.', hiddenCheckbox: 'Faire participer l’Italie, la Pologne, l’Indonésie, la Chine et les EAU à la Coupe du monde' },
    topbar: { settings: 'Paramètres' },
    tabs: { navigation: 'Navigation mobile', news: 'Actus', fixtures: 'Matchs', standings: 'Classement', knockout: 'Phase finale', data: 'Données' },
    action: { continue: 'Continuer', readNews: 'Lire les actus', simulateNext: 'Simuler la journée', restart: 'Recommencer', completed: 'Terminé' },
    settings: { title: 'Paramètres', language: 'Langue', restart: 'Recommencer', restartConfirm: 'Recommencer et effacer la simulation mobile actuelle ?', close: 'Fermer les paramètres' },
    news: { previous: 'Précédent', next: 'Suivant', pcMore: 'Utilisez la version PC pour plus de surprises et de fonctions !', empty: 'Aucune actu.' },
    fixtures: { previousDay: 'Journée précédente', nextDay: 'Journée suivante', noMatches: 'Aucun match ce jour-là.' },
    standings: { groupStandings: 'Classements de groupe', knockout: 'Phase finale', roundOf32: '32es', roundOf16: '8es', quarterFinal: 'Quarts', semiFinal: 'Demi-finales', thirdPlace: '3e place', final: 'Finale' },
    data: { goals: 'Buteurs', assists: 'Passeurs', pcMore: 'Utilisez la version PC pour voir plus de données joueurs et équipes.', empty: 'Aucune donnée.' },
    team: { squad: 'Effectif', fixtures: 'Matchs', tactic: 'Tactique', close: 'Fermer la fiche équipe' },
  },
    teamNames: {

    mexico: 'Mexique', south_africa: 'Afrique du Sud', south_korea: 'Corée du Sud',
    czechia: 'Tchéquie', canada: 'Canada', bosnia_herzegovina: 'Bosnie-Herzégovine',
    switzerland: 'Suisse', qatar: 'Qatar', brazil: 'Brésil', morocco: 'Maroc',
    scotland: 'Écosse', haiti: 'Haïti', united_states: 'États-Unis',
    australia: 'Australie', paraguay: 'Paraguay', turkiye: 'Turquie',
    germany: 'Allemagne', curacao: 'Curaçao', ivory_coast: 'Côte d\'Ivoire',
    ecuador: 'Équateur', netherlands: 'Pays-Bas', japan: 'Japon',
    tunisia: 'Tunisie', sweden: 'Suède', belgium: 'Belgique', iran: 'Iran',
    egypt: 'Égypte', new_zealand: 'Nouvelle-Zélande', spain: 'Espagne',
    uruguay: 'Uruguay', saudi_arabia: 'Arabie Saoudite', cape_verde: 'Cap-Vert',
    france: 'France', senegal: 'Sénégal', norway: 'Norvège', iraq: 'Irak',
    argentina: 'Argentine', austria: 'Autriche', algeria: 'Algérie',
    jordan: 'Jordanie', portugal: 'Portugal', colombia: 'Colombie',
    uzbekistan: 'Ouzbékistan', dr_congo: 'RD Congo', england: 'Angleterre',
    croatia: 'Croatie', panama: 'Panama', ghana: 'Ghana',
    italy: 'Italie',
    tbd: 'TBD',
    china: 'Chine',

    indonesia: "Indonésie",
    united_arab_emirates: "EAU",
    poland: "Pologne",

  },
};
